<template>
  <div class="card-item p-3">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h3 class="title">Yetkilendirme</h3>

    </div>

    <v-app>
      <v-data-table
          :headers="headers"
          :items="rightList"
          :items-per-page="20"
          class="elevation-1"
          :search="search">
        <template v-slot:top>
          <v-text-field
              v-model="search"
              label="Arama"
              class="mx-4"/>
        </template>
        <template v-slot:item.authorization="{ item }">
          <div>
            <div class="row">
              <button class="theme-btn theme-btn-small" @click="disableRight(item)" :class="roleRightMap[item.id] ? '' : 'theme-btn-gray'" type="button">
                <i class="la la-minus mr-1"></i>
              </button>
              <button class="theme-btn theme-btn-small ml-2" @click="enableRight(item)" :class="roleRightMap[item.id] ? 'theme-btn-gray' : ''" type="button">
                <i class="la la-plus mr-1"></i>
              </button>
            </div>
          </div>
        </template>
      </v-data-table>
    </v-app>
    <div class="section-block mb-4"></div>
  </div>
</template>

<script>
export default {
  name: "RoleRightList",
  data () {
    return {
      search: '',
      rightList: [],
      roleRightMap: {},
      headers: [
        {
          text: 'Kodu',
          align: 'start',
          sortable: true,
          value: 'roleTag',
        },
        {
          text: 'Adı',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Group',
          sortable: true,
          value: 'group'
        },
        {
          text: 'Açıklaması',
          sortable: true,
          value: 'description',
        },
        {
          text: 'Yetkilendirme',
          sortable: true,
          value: 'authorization',
          formatter: this.getFormatValue()
        }
      ]
    }
  },
  computed:{
    roleName:{
      get(){
        return this.$store.getters.getSelectedRoleName;
      }
    }
  },
  methods:{
    enableRight(right){
      this.$store.dispatch("grantRight", { rightId : right.id, roleName: this.roleName}).then(()=>{
        this.loadRoleRights();
      })
    },
    disableRight(right){
      this.$store.dispatch("revokeRight", { rightId : right.id, roleName: this.roleName}).then(()=>{
        this.loadRoleRights();
      })
    },
    getFormatValue(){
      return "asdasdasd";
    },
    filterCruiseRooms (value, search, item) {
      // if(value == null || search == null){
      //   return false;
      // }
      // if(this.roomMap !== undefined){
      //   if(typeof value === 'number'){
      //     if(this.roomMap[item.roomId].name.toLowerCase().indexOf(search.toLowerCase()) !== -1){
      //       return true;
      //     }
      //   }
      // }
      //
      // return value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
    },
    loadRoleRights(){
      this.$store.dispatch("loadRoleRights",this.roleName).then(response =>{
        this.roleRightMap = response.reduce(function (map,right){
          map[right.id] = right
          return map
        },{})
      });
    }
  },
  mounted() {
    this.$store.dispatch("loadRights").then(response =>{
      this.rightList = response;
    });
    this.loadRoleRights();
  }
}
</script>

<style scoped>

</style>